// removed by extract-text-webpack-plugin
module.exports = {"TrueBlack":"#000000","spotlight":"Gd40db0"};